import { useSwrNoAuth } from "../swr/useSwrNoAuth";


export type SelectedQuestions = {
  id: string;
  restaurant: string;
  question: string;
  question_content: string;
  order: number;
}[]
export const useFetchManlaboSurveySelectedQuestionsCustomerByRestaurantId = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `manzokudo_labo/restaurants/${restaurantId}/survey/questions/selected/customer/` : null;
  const { data: selectedQuestions, error, isLoading: isLoadingSelectedQuestions } = useSwrNoAuth<SelectedQuestions>(fetcherKey)
  return { selectedQuestions, isLoadingSelectedQuestions, error };
};